import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { Divider, Popover } from "@mui/material";
import { CustomButton } from "../../../../components/Button";
import { useSearchParams } from "react-router-dom";
import { tokensCost } from "../../../../utils/functions";
import { useSelector } from "react-redux";
import { TfiHelpAlt } from "react-icons/tfi";

type ThreadAgeProps = {
  setAnchorEl3: React.Dispatch<
    React.SetStateAction<HTMLButtonElement | HTMLDivElement | null>
  >;
  setManageSummary: (value: string) => void;
  generatedSummary?: string;
};

const ThreadAge: React.FC<ThreadAgeProps> = ({
  setAnchorEl3,
  setManageSummary,
  generatedSummary,
}) => {
  const metaData = useSelector((state: any) => state.metaData);
  const theme = useTheme();
  const [anchorEl2, setAnchorEl2] = React.useState<HTMLButtonElement | null>(
    null
  );
  const [open2, setOpen2] = React.useState(Boolean(anchorEl2));
  const bgdefault = theme.palette.background.default;
  const [searchParams, setSearchParams] = useSearchParams();
  const [hydratingThread, setHydratingThread] = React.useState(false);
  React.useEffect(() => {
    if (generatedSummary) {
      setAnchorEl2(null);
      setHydratingThread(false);
    }
  }, [generatedSummary]);

  return (
    <>
      <TfiHelpAlt
        color={"#2a945f"}
        cursor={"pointer"}
        onClick={(event: any) => {
          setAnchorEl2(event.currentTarget);
          setOpen2(Boolean(event.currentTarget));
        }}
      />

      <Popover
        open={anchorEl2 ? true : false}
        anchorEl={anchorEl2}
        onClose={() => {
          setAnchorEl2(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{ marginTop: "20px" }}
      >
        <div
          className="thread-age-content"
          style={{ backgroundColor: bgdefault }}
        >
          <div style={{ fontSize: "12px", margin: "20px 0px" }}>
            <p>
              <b>“Thread Health”</b> measures how much context is left in your
              current conversation. As you chat more, your AI gets “full” and
              might start to forget earlier parts of your conversation.
            </p>
            <p>🟢 A high score means your context is still fresh.</p>
            <p>
              🔴 A low score means it’s time to hydrate for the best results.
            </p>
            <p>
              <b>“Hydrate Thread”</b> re-sends your memory and context to the AI
              so it remembers everything again.
            </p>
            <p>
              <b>“Thread Memory”</b> is where your memory and context are
              stored—you can edit them anytime, and use them to guide future
              chats.
            </p>
          </div>

          <Divider sx={{ margin: "0px 1px", backgroundColor: "#2a945f" }} />
          <div className="thread-age-btns">
            <div style={{ width: "50%" }}>
              <CustomButton
                text={hydratingThread ? "" : "Hydrate thread"}
                color="rgba(52, 180, 116)"
                border={
                  searchParams.get("conversation_id")
                    ? "1px solid rgba(52, 180, 116)"
                    : "none"
                }
                bgcolor={theme.palette.background.default}
                submit={() => {
                  setHydratingThread(true);
                  setManageSummary("hydrate");
                }}
                fontWeight="500"
                fontSize="14px"
                width="100%"
                disabled={searchParams.get("conversation_id") ? false : true}
                endIcon={
                  metaData.tokenMetadata.actionsTokensCost && !hydratingThread
                    ? tokensCost(
                        metaData.tokenMetadata.actionsTokensCost
                          .generate_summary,
                        { fontSize: "10px", width: 13, height: 13 }
                      )
                    : undefined
                }
              />
            </div>
            <div style={{ width: "50%" }}>
              <CustomButton
                text={"Thread Memory"}
                color={theme.palette.primary.main}
                submit={(event) => {
                  setAnchorEl3(anchorEl2);
                  setAnchorEl2(null);
                }}
                fontWeight="500"
                fontSize="14px"
                bgcolor="#2a945f"
                width="100%"
                disabled={searchParams.get("conversation_id") ? false : true}
              />
            </div>
          </div>
        </div>
      </Popover>
    </>
  );
};

export default ThreadAge;
